import React, { useEffect, useState } from 'react';
import { ownerListPayouts, ownerUpdatePayout } from '../lib/api';
import { Loader2, Check, X, Truck } from 'lucide-react';
import { toast } from 'sonner';

const STATUSES = ['pending', 'approved', 'paid', 'rejected'];

export default function OwnerPayouts() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => { setLoading(true); try { setRows(await ownerListPayouts()); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try {
      const updated = await ownerUpdatePayout(id, status);
      setRows(list => list.map(x => x.id === id ? { ...x, ...updated } : x));
      toast.success(`Status: ${status}`);
    } catch (err) { toast.error('Failed'); }
  };

  if (loading) return <div className="flex items-center gap-2 text-white/60 py-10"><Loader2 className="w-5 h-5 animate-spin" /> Loading…</div>;

  return (
    <div className="card-shell overflow-hidden" data-testid="owner-payouts-tab">
      {rows.length === 0 ? (
        <div className="p-10 text-center text-white/50 text-[13.5px]">No payout requests yet.</div>
      ) : (
        <table className="w-full text-[13.5px]">
          <thead className="bg-white/[0.03] text-white/55">
            <tr>
              <th className="text-left px-5 py-2">Creator</th>
              <th className="text-left px-3 py-2">Method</th>
              <th className="text-left px-3 py-2">Destination</th>
              <th className="text-right px-3 py-2">Amount</th>
              <th className="text-left px-3 py-2">Status</th>
              <th className="px-5 py-2"></th>
            </tr>
          </thead>
          <tbody>
            {rows.map(p => (
              <tr key={p.id} className="border-t border-white/5">
                <td className="px-5 py-3">
                  <div className="font-semibold">{p.creator?.name}</div>
                  <div className="text-[12px] text-white/50">{p.creator?.email}</div>
                </td>
                <td className="px-3 py-3 capitalize">{p.method}</td>
                <td className="px-3 py-3 text-white/70 truncate max-w-[260px]">{p.destination}</td>
                <td className="px-3 py-3 text-right font-semibold">${p.amount.toFixed(2)}</td>
                <td className="px-3 py-3">
                  <select value={p.status} onChange={e => setStatus(p.id, e.target.value)} className="input-field text-[12.5px] py-1.5">
                    {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-5 py-3 text-right">
                  {p.status !== 'paid' && p.status !== 'rejected' && (
                    <div className="flex justify-end gap-2">
                      <button onClick={() => setStatus(p.id, 'approved')} className="text-[#22d3ee] hover:text-white" aria-label="Approve"><Check className="w-4 h-4" /></button>
                      <button onClick={() => setStatus(p.id, 'paid')} className="text-[#34d399] hover:text-white" aria-label="Mark paid"><Truck className="w-4 h-4" /></button>
                      <button onClick={() => setStatus(p.id, 'rejected')} className="text-[#ff6b8a] hover:text-white" aria-label="Reject"><X className="w-4 h-4" /></button>
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
